<template>
  <div>
    <v-dialog v-model="showDialog" max-width="550px" persistent>
      <v-card class="elevation-2">
        <v-card-title class="text-h5 schuberthMain white--text elevation-1">
          {{ info.title }}
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col class="shrink" cols="4"> {{info.type == "warning" ? 'vrsl.' : '' }} Störungszeitraum </v-col>
            <v-spacer></v-spacer>
            <v-col class="shrink" cols="8">
              {{ info.start }} - {{ info.end }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="shrink" cols="12">
              <span class="text-h6"><strong>{{ info.info }}</strong></span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col class="shrink" cols="12"> Erstellt durch: {{info.user}} </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-btn class="schuberthMain white--text" @click="hide()">Close</v-btn>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NotificationInfo",

  props: ["info", "value"],

  data: () => ({
    timeout: 15000,
  }),
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    hide() {
      this.showDialog = false;
    },
  },
};
</script>
<style scoped>
</style>
